export default __webpack_public_path__ + "media/Pangaea.7122aaff.svg";